export default "__VITE_ASSET__D8ZYXIJD__"